/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReportPaymentEventDto = {
    event: ReportPaymentEventDto.event;
    /**
     * Stripe SDK error code
     */
    errorCode?: string;
    /**
     * Error message the app showed to the client
     */
    errorMessage?: string;
};
export namespace ReportPaymentEventDto {
    export enum event {
        PAYMENT_SHEET_CANCELLED = 'payment_sheet_cancelled',
        PAYMENT_SHEET_INIT_FAILED = 'payment_sheet_init_failed',
        PAYMENT_SHEET_FAILED = 'payment_sheet_failed',
    }
}

